import React from 'react';
import PropTypes from 'prop-types';
import Heading from '../../../common/heading/Heading';
import {
	ONBOARDING_FORGOT_PASSWORD_SENT_TITLE,
	ONBOARDING_FORGOT_PASSWORD_SENT_SUBTITLE,
} from '../../../../constants/Copy';
import Message from '../../../common/message/Message';

const PasswordSent = ({ email }) => (
	<>
		<Heading>{ONBOARDING_FORGOT_PASSWORD_SENT_TITLE}</Heading>
		<p className="onboarding__text">
			<Message
				message={ONBOARDING_FORGOT_PASSWORD_SENT_SUBTITLE}
				values={{
					email: <strong>{email}</strong>,
				}}
			/>
		</p>
	</>
);

PasswordSent.propTypes = {
	email: PropTypes.string.isRequired,
};

export default PasswordSent;
